<template>
  <el-dialog class="exam-type-select-popup" :visible.sync="show" width="600px" center>
    <template #title>选择布置类型</template>

    <template #default>
      <ul class="types">
        <li
          class="type"
          :class="{ selected: value === type.value }"
          v-for="type in types"
          :key="type.value"
          @click="select(type.value)"
        >
          <div class="label">{{ type.label }}</div>
          <p class="text">{{ type.text }}</p>
          <p class="tips" v-for="(tip, idx) in type.tips" :key="idx">{{ tip }}</p>
        </li>
      </ul>

      <div class="footer">
        <el-button type="primary" @click="change">确认布置</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { ExamQuestionType } from 'kuaidong-model'
import { BaseComponent, Component, Emit, PropSync } from 'kuaidong-component'
@Component({
  components: {},
})
export default class QuestionTypeSelectPopup extends BaseComponent {
  @PropSync('visible', { type: Boolean, default: false })
  show!: boolean

  value = ExamQuestionType.TestByPractice

  types = [
    {
      value: ExamQuestionType.TestByPractice,
      label: this.type2Label(ExamQuestionType.TestByPractice),
      text: '学生在天天跳绳app闯关练习。',
      tips: ['学生需要达成条件才可以解锁,学生完成所有题目将会获取虚拟奖励'],
    },

    {
      value: ExamQuestionType.TestByExam,
      label: this.type2Label(ExamQuestionType.TestByExam),
      text: '学生在天天跳绳app完成考试，教师可下载学生考试数据。',
      tips: ['*建议学校完成学生认证。'],
    },
  ]

  select(type: ExamQuestionType) {
    this.value = type
  }

  @Emit('change')
  change() {
    return this.value
  }

  type2Label(type: ExamQuestionType) {
    switch (type) {
      case ExamQuestionType.TestByPractice:
        return '线上练习'
      case ExamQuestionType.TestByExam:
        return '线上考试'
      default:
        return ''
    }
  }
}
</script>

<style lang="less">
.exam-type-select-popup {
  > .el-dialog {
    padding: 0 100px;
    > .el-dialog__header {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #0a1629;
    }
    > .el-dialog__body {
      display: flex;
      flex-direction: column;
      border-radius: 16px;
      flex: auto;
      padding: 0;
      text-align: left;
      overflow: hidden;

      > .types {
        flex: 1;
        overflow: auto;

        > .type {
          margin: 8px 16px;
          padding: 16px;
          background: #f7f8fa;
          border-radius: 8px;
          &:hover {
            cursor: pointer;
          }
          + .type {
            margin: 24px 16px 8px 16px;
          }

          &.selected {
            border: 1.5px solid #3366ff;
            background: #f5f7ff;

            > .label,
            > .text {
              color: #3366ff;
            }

            > .tips {
              color: rgba(51, 102, 255, 0.6);
            }
          }

          > .label {
            line-height: 22px;
            font-size: 16px;
            font-weight: 500;
            color: #2d2f33;
          }

          > .text {
            margin: 8px 0 0 0;
            line-height: 20px;
            font-size: 14px;
            color: #4d4d4d;
          }

          > .tips {
            margin: 8px 0 0 0;
            color: #8f8f8f;
          }
        }
      }
      > .footer {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px;
        > .el-button {
          width: 135px;
          background: #2981f8;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
